'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.daysBefore;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/number/daysBefore.js
// module id = 159
// module chunks = 0